/* Real Shopify variants own the pack prices. The form also works without JS. */
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-offer-form]');
    const choices = [...root.querySelectorAll('input[name="id"]')];
    const status = root.querySelector('[data-offer-status]');
    const submit = form.querySelector('[type="submit"]');
    const sticky = root.querySelector('[data-sticky-add]');
    let busy = false;
    function update() {
      const choice = choices.find(input => input.checked);
      if (!choice) return;
      root.querySelectorAll('[data-offer-price]').forEach(el => { el.textContent = choice.dataset.price; });
      root.querySelectorAll('[data-offer-selected]').forEach(el => { el.textContent = choice.dataset.label; });
      const saving = root.querySelector('[data-offer-saving]');
      saving.textContent = choice.dataset.saving;
      saving.hidden = !choice.dataset.saving;
      root.querySelector('[data-offer-stock]').textContent = choice.dataset.stock;
      submit.disabled = choice.disabled || busy;
      if (sticky) sticky.disabled = submit.disabled;
      submit.querySelector('[data-add-label]').textContent = choice.disabled ? 'Sold out' : 'Add pack to cart';
      if (status) status.textContent = '';
    }
    choices.forEach(input => input.addEventListener('change', () => {
      update();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }));
    root.querySelectorAll('[data-gallery-thumb]').forEach(button => button.addEventListener('click', () => {
      const main = root.querySelector('[data-gallery-main]');
      main.src = button.dataset.src;
      main.removeAttribute('srcset');
      main.alt = button.dataset.alt;
      root.querySelectorAll('[data-gallery-thumb]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    if (sticky) {
      root.querySelector('[data-sticky-wrap]').hidden = false;
      sticky.hidden = false;
      sticky.addEventListener('click', () => { if (!busy) form.requestSubmit(); });
    }
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (busy) return;
      const choice = choices.find(input => input.checked);
      if (!choice || choice.disabled) return;
      busy = true;
      submit.disabled = true;
      if (sticky) sticky.disabled = true;
      form.setAttribute('aria-busy', 'true');
      submit.querySelector('[data-add-label]').textContent = 'Adding…';
      status.textContent = '';
      try {
        const response = await fetch(root.dataset.addUrl, {
          method: 'POST', headers: { 'Accept': 'application/json' },
          body: new FormData(form), credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(result.description || result.message || 'This pack could not be added. Please check its availability.');
        }
        status.textContent = 'Added. Opening your cart…';
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this pack. Please try again.';
        busy = false;
        submit.disabled = false;
        if (sticky) sticky.disabled = false;
        submit.querySelector('[data-add-label]').textContent = 'Add pack to cart';
        form.removeAttribute('aria-busy');
      }
    });
    update();
  }
  const scan = scope => scope.querySelectorAll('[data-lavelle-offer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
